import List from './List';
import MainLayout from '../../layouts/MainLayout';
import New from './New';
import React from 'react';
import RequireAuth from '../../guards/RequireAuth';
import { Route } from 'react-router';
import Show from './Show';

const Routes = (
  <Route
    path="/settings/examinee-vendors"
    element={
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    }
  >
    <Route path="/settings/examinee-vendors" element={<List />} />
    <Route path=":id/*" element={<Show />} />
    <Route path="new" element={<New />} />
  </Route>
);

export default Routes;
